import {
  initialState,
  IConfigurationState,
  ConfigurationDispatchTypes,
  FETCH_CONFIGURATION,
  FAIL_FETCH_CONFIGURATION,
  SUCCESS_FETCH_CONFIGURATION,
} from '.'

export const configurationReducer = (state = initialState, action: ConfigurationDispatchTypes): IConfigurationState => {
  switch (action.type) {
    case FETCH_CONFIGURATION:
      return {
        ...state,
        error: null,
        isLoading: true,
      }
    case SUCCESS_FETCH_CONFIGURATION:
      return {
        ...state,
        error: null,
        data: action.payload,
        isLoading: false,
      }
    case FAIL_FETCH_CONFIGURATION:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      }
    default:
      return state
  }
}
